import classNames from 'classnames';
import { FC } from 'react';

import { Spinner } from '../spinner';

export interface LoaderProps {
  className?: string;
  embedInParent?: boolean;
}

/** A full-area veil with the one `Spinner` — for a page or a block that is not ready yet. */
export const Loader: FC<LoaderProps> = ({ className, embedInParent = false }) => {
  return (
    <div
      className={classNames(
        'z-[100] grid place-items-center bg-ink-muted/60',
        embedInParent ? 'absolute inset-0 h-full w-full' : 'fixed inset-0',
        className,
      )}
    >
      <Spinner size="xl" className="text-primary" />
    </div>
  );
};
